export default __webpack_public_path__ + "f468d3608aae3ae7f5b8f4a7243bae33.svg";